module.exports = __webpack_public_path__ + "static/0-a9151b47ca35dc1f55cc0c71a7c0b6af.png";